module.exports = __webpack_public_path__ + "static/transparenzbericht_2023-4df47a6561f9b54b93d0110ac0fe9dcc.pdf";